import React from 'react';

const Us1_pre_sci = () => {
  return (
    <div>
      
    </div>
  );
}

export default Us1_pre_sci;
